export default {
    setUsers(state, users) {
        state.usuarios = users;
        //state.usersLoaded = true;
    },
    setUsersAuth(state, users) {
        state.usuariosAuth = users;
        //state.usersLoaded = true;
    },
    setLoaded(state, b) {
        state.usersLoaded = b;
    },
    setUsuarioViendo(state, u) {
        state.usuarioViendo = u;
    }
}